import { render, staticRenderFns } from "./mailSettingAdd.vue?vue&type=template&id=4e8b090f&scoped=true&"
import script from "./mailSettingAdd.vue?vue&type=script&lang=js&"
export * from "./mailSettingAdd.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingAdd.vue?vue&type=style&index=0&id=4e8b090f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b090f",
  null
  
)

export default component.exports